"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMainStore = void 0;
var vue_1 = require("vue");
var pinia_1 = require("pinia");
exports.useMainStore = (0, pinia_1.defineStore)('main', function () {
    var theme = localStorage.getItem("vueuse-color-scheme");
    var isDark = (0, vue_1.ref)(theme === 'dark');
    function changeTheme() {
        isDark.value = !isDark.value;
    }
    var isFullScreen = (0, vue_1.ref)(false);
    function toggleFullScreen() {
        isFullScreen.value = !isFullScreen.value;
    }
    var isCollapse = (0, vue_1.ref)(false);
    /* eslint-disable */
    var reload = (0, vue_1.inject)("reload");
    function reloadApp() {
        if (reload) {
            reload.value = false;
        }
        (0, vue_1.nextTick)(function () {
            if (reload) {
                reload.value = true;
            }
        });
    }
    function onTrigger() {
        if (reload) {
            reload.value = false;
        }
        (0, vue_1.nextTick)(function () {
            if (reload) {
                reload.value = true;
            }
        });
        isCollapse.value = !isCollapse.value;
    }
    return { isDark: isDark, changeTheme: changeTheme, isCollapse: isCollapse, onTrigger: onTrigger, reloadApp: reloadApp, isFullScreen: isFullScreen, toggleFullScreen: toggleFullScreen };
});
